module.exports = "/_next/static/images/search_bg_20-bc2cb6a111e89ee114573168ca284afd.jpg";